import React from "react";
const Bar3 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="h-6 w-6 text-white"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  );
};

const AmpBar3 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      style={{ width: "30px" }}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  );
};

const SunIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
      <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z" />
    </svg>
  );
};

const MoonIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
      <path
        fillRule="evenodd"
        d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z"
        clipRule="evenodd"
      />
    </svg>
  );
};

const PorfileAvatar = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
      <path
        fillRule="evenodd"
        d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};

const ProfileAvatarWhite = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2.99057C8.60077 2.99031 7.22593 3.35706 6.01273 4.0542C4.79952 4.75134 3.79038 5.75449 3.08603 6.96352C2.38168 8.17256 2.00675 9.54519 1.99868 10.9444C1.9906 12.3436 2.34966 13.7205 3.04001 14.9376C3.50662 14.3311 4.10644 13.8402 4.7931 13.5025C5.47975 13.1649 6.23485 12.9898 7.00001 12.9906H13C13.7652 12.9898 14.5203 13.1649 15.2069 13.5025C15.8936 13.8402 16.4934 14.3311 16.96 14.9376C17.6504 13.7205 18.0094 12.3436 18.0013 10.9444C17.9933 9.54519 17.6183 8.17256 16.914 6.96352C16.2096 5.75449 15.2005 4.75134 13.9873 4.0542C12.7741 3.35706 11.3993 2.99031 10 2.99057ZM17.943 17.0666C19.28 15.3235 20.0032 13.1873 20 10.9906C20 5.46757 15.523 0.99057 10 0.99057C4.47701 0.99057 1.12532e-05 5.46757 1.12532e-05 10.9906C-0.00329018 13.1874 0.719917 15.3236 2.05701 17.0666L2.05201 17.0846L2.40701 17.4976C3.3449 18.5941 4.5094 19.4742 5.82024 20.0772C7.13109 20.6802 8.55711 20.9918 10 20.9906C12.0273 20.9943 14.0074 20.3785 15.675 19.2256C16.3859 18.7344 17.0306 18.1536 17.593 17.4976L17.948 17.0846L17.943 17.0666ZM10 4.99057C9.20436 4.99057 8.4413 5.30664 7.87869 5.86925C7.31608 6.43186 7.00001 7.19492 7.00001 7.99057C7.00001 8.78622 7.31608 9.54928 7.87869 10.1119C8.4413 10.6745 9.20436 10.9906 10 10.9906C10.7957 10.9906 11.5587 10.6745 12.1213 10.1119C12.6839 9.54928 13 8.78622 13 7.99057C13 7.19492 12.6839 6.43186 12.1213 5.86925C11.5587 5.30664 10.7957 4.99057 10 4.99057Z"
      fill="white"
    />
  </svg>
);

const LeftArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-4 w-4"
      strokeWidth={1}
      stroke="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};

const GotoArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      viewBox="0 0 24 24"
      fill="currentColor"
      strokeWidth={1}
      className="h-[19px] w-6"
      fontSize={24}
    >
      <path
        fillRule="evenodd"
        d="M8.25 3.75H19.5a.75.75 0 01.75.75v11.25a.75.75 0 01-1.5 0V6.31L5.03 20.03a.75.75 0 01-1.06-1.06L17.69 5.25H8.25a.75.75 0 010-1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};

const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="currentColor" className="h-6 w-6">
      <path
        fillRule="evenodd"
        d="M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};

const FacebookIcon = () => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
    >
      <title>Artboard 2 Copy 6</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Artboard-2-Copy-6">
          <g id="Group-2">
            <path
              d="M32,16.0000549 C32,24.837103 24.8369931,32 15.9999451,32 C7.16289703,32 4.37128358e-14,24.8369931 4.37128358e-14,16.0000549 C4.37128358e-14,7.16399548 7.16300688,-3.55271368e-15 15.9999451,-3.55271368e-15 C24.8369931,-3.55271368e-15 32,7.16399548 32,16.0000549 Z"
              id="Shape-Copy"
              fill="#FFFFFF"
            />
            <path
              d="M32,16.0000549 C32,24.837103 24.8369931,32 15.9999451,32 C7.16289703,32 4.37128358e-14,24.8369931 4.37128358e-14,16.0000549 C4.37128358e-14,7.16399548 7.16300688,-3.55271368e-15 15.9999451,-3.55271368e-15 C24.8369931,-3.55271368e-15 32,7.16399548 32,16.0000549 Z"
              id="Shape-Copy"
              fill="#FFFFFF"
            />
            <g id="Group" transform="translate(1.000000, 1.000000)">
              <circle id="Oval" fill="#3B5998" cx="15" cy="15" r="15" />
              <path
                d="M16.5708285,10.5205281 C16.4937294,10.5619812 16.4278633,10.6188588 16.3732302,10.6916428 C16.3180865,10.7639448 16.2741757,10.8521532 16.2414979,10.955786 C16.2083096,11.0594189 16.1919707,11.173656 16.1919707,11.2980155 L16.1919707,12.9469827 L19.1911765,12.9469827 L19.1911765,15.2808908 L16.1919707,15.2808908 L16.1919707,22.3125 L13.3244972,22.3125 L13.3244972,15.2808908 L10.7536765,15.2808908 L10.7536765,12.9469827 L13.3244972,12.9469827 L13.3244972,11.5472163 C13.3244972,11.0700232 13.4123187,10.6135566 13.5879616,10.1778167 C13.7636046,9.74255871 14.0056243,9.35887618 14.3129995,9.02676907 C14.6208852,8.69514395 14.9834042,8.43582083 15.4005562,8.24879969 C15.8182189,8.06226057 16.2797922,7.96875 16.7852763,7.96875 L19.1911765,7.96875 L19.1911765,10.4578664 L16.7852763,10.4578664 C16.7188996,10.4578664 16.6479276,10.4790749 16.5708285,10.5205281 Z"
                id="fb-copy"
                fill="#FFFFFF"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const InstaIcon = () => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
    >
      <title>Artboard 2 Copy 10</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Artboard-2-Copy-10">
          <g id="Group-3">
            <g id="Group-2">
              <path
                d="M32,16.0000549 C32,24.837103 24.8369931,32 15.9999451,32 C7.16289703,32 4.37128358e-14,24.8369931 4.37128358e-14,16.0000549 C4.37128358e-14,7.16399548 7.16300688,-3.55271368e-15 15.9999451,-3.55271368e-15 C24.8369931,-3.55271368e-15 32,7.16399548 32,16.0000549 Z"
                id="Shape-Copy"
                fill="#FFFFFF"
              />
              <g id="Group" transform="translate(1.000000, 1.000000)" fill="#833AB4">
                <path
                  d="M14.9999485,0 C23.2846811,0 30,6.71624576 30,15.0000515 C30,23.2838572 23.2846811,30 14.9999485,30 C6.71521597,30 0,23.2837542 0,15.0000515 C0,6.71634874 6.71531895,0 14.9999485,0 L14.9999485,0 Z"
                  id="Shape"
                />
              </g>
            </g>
            <g id="glyph-logo_May2016" transform="translate(8.000000, 8.000000)" fill="#FFFFFF">
              <path
                d="M7.99998412,1.44147062 C10.1360866,1.44147062 10.389087,1.44960017 11.2326547,1.4880885 C12.0126468,1.52368704 12.4362408,1.65401387 12.718171,1.76354048 C13.0915586,1.90866563 13.3580872,2.08205366 13.6380168,2.36198324 C13.9179463,2.64191283 14.0913344,2.90844135 14.2364278,3.28182899 C14.3459861,3.5637592 14.476313,3.98735315 14.5119115,4.7673135 C14.5503998,5.61091297 14.5585294,5.86391342 14.5585294,8.00001588 C14.5585294,10.1361183 14.5503998,10.3891188 14.5119115,11.2326865 C14.476313,12.0126786 14.3459861,12.4362726 14.2364278,12.7182028 C14.0913344,13.0915904 13.9179463,13.3581189 13.6380168,13.6380485 C13.3580872,13.9179781 13.0915586,14.0913661 12.718171,14.2364595 C12.4362408,14.3460179 12.0126468,14.4763447 11.2326547,14.5119433 C10.3892141,14.5504316 10.1362136,14.5585611 7.99998412,14.5585611 C5.86375464,14.5585611 5.61075419,14.5504316 4.7673135,14.5119433 C3.9873214,14.4763447 3.56372745,14.3460179 3.28182899,14.2364595 C2.9084096,14.0913661 2.64188107,13.9179781 2.36195149,13.6380485 C2.08202191,13.3581189 1.90863387,13.0915904 1.76354048,12.7182028 C1.65398211,12.4362726 1.52365528,12.0126786 1.48805675,11.2327183 C1.44956842,10.3891188 1.44143887,10.1361183 1.44143887,8.00001588 C1.44143887,5.86391342 1.44956842,5.61091297 1.48805675,4.76734525 C1.52365528,3.98735315 1.65398211,3.5637592 1.76354048,3.28182899 C1.90863387,2.90844135 2.08202191,2.64191283 2.36195149,2.36198324 C2.64188107,2.08205366 2.9084096,1.90866563 3.28182899,1.76354048 C3.56372745,1.65401387 3.9873214,1.52368704 4.76728174,1.4880885 C5.61088121,1.44960017 5.86388166,1.44147062 7.99998412,1.44147062 M7.99998412,0 C5.82729869,0 5.55489529,0.00920925451 4.70161023,0.0481421718 C3.85007175,0.0870115771 3.26855496,0.222228838 2.75966426,0.420005518 C2.23359353,0.624450968 1.78745279,0.897997583 1.34270931,1.34274106 C0.897965827,1.78748454 0.624419212,2.23362529 0.419973762,2.75969602 C0.222197082,3.26858672 0.086979821,3.8501035 0.0481104158,4.70164199 C0.00917749846,5.55489529 0,5.82733045 0,8.00001588 C0,10.1727013 0.00917749846,10.4451365 0.0481104158,11.2983898 C0.086979821,12.1499283 0.222197082,12.731445 0.419973762,13.2403357 C0.624419212,13.7663747 0.897965827,14.2125472 1.34270931,14.6572907 C1.78745279,15.1020342 2.23359353,15.3755808 2.75966426,15.5800262 C3.26855496,15.7778029 3.85007175,15.9130202 4.70161023,15.9518896 C5.55489529,15.9908225 5.82729869,16 7.99998412,16 C10.1726696,16 10.4451047,15.9908225 11.298358,15.9518896 C12.1498965,15.9130202 12.7314133,15.7778029 13.240304,15.5800262 C13.7663747,15.3755808 14.2125155,15.1020342 14.6572589,14.6572907 C15.1020024,14.2125472 15.375549,13.7664065 15.5799945,13.2403357 C15.7777712,12.731445 15.9129884,12.1499283 15.9518578,11.2983898 C15.9907907,10.4451365 16,10.1727013 16,8.00001588 C16,5.82733045 15.9907907,5.55489529 15.9518578,4.70164199 C15.9129884,3.8501035 15.7777712,3.26858672 15.5799945,2.75969602 C15.375549,2.23362529 15.1020024,1.78748454 14.6572589,1.34274106 C14.2125155,0.897997583 13.7663747,0.624450968 13.240304,0.420005518 C12.7314133,0.222228838 12.1498965,0.0870115771 11.298358,0.0481421718 C10.4451047,0.00920925451 10.1726696,0 7.99998412,0"
                id="Fill-1"
              />
              <path
                d="M8,4 C5.79087079,4 4,5.79087079 4,8 C4,10.2091292 5.79087079,12 8,12 C10.2091292,12 12,10.2091292 12,8 C12,5.79087079 10.2091292,4 8,4 L8,4 Z M8,10.5964983 C6.5660109,10.5964983 5.40350172,9.4339891 5.40350172,8 C5.40350172,6.5660109 6.5660109,5.40350172 8,5.40350172 C9.4339891,5.40350172 10.5964983,6.5660109 10.5964983,8 C10.5964983,9.4339891 9.4339891,10.5964983 8,10.5964983 L8,10.5964983 Z"
                id="Fill-2"
              />
              <path
                d="M12.8,3.99998677 C12.8,4.44181869 12.4418452,4.8 12.0000132,4.8 C11.5581813,4.8 11.2,4.44181869 11.2,3.99998677 C11.2,3.55815484 11.5581813,3.2 12.0000132,3.2 C12.4418452,3.2 12.8,3.55815484 12.8,3.99998677"
                id="Fill-3"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const TwitterIcon = () => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
    >
      <title>Artboard 2 Copy 7</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Artboard-2-Copy-7">
          <g id="Group-2">
            <path
              d="M32,16.0000549 C32,24.837103 24.8369931,32 15.9999451,32 C7.16289703,32 4.37128358e-14,24.8369931 4.37128358e-14,16.0000549 C4.37128358e-14,7.16399548 7.16300688,-3.55271368e-15 15.9999451,-3.55271368e-15 C24.8369931,-3.55271368e-15 32,7.16399548 32,16.0000549 Z"
              id="Shape-Copy"
              fill="#FFFFFF"
            />
            <path
              d="M32,16.0000549 C32,24.837103 24.8369931,32 15.9999451,32 C7.16289703,32 4.37128358e-14,24.8369931 4.37128358e-14,16.0000549 C4.37128358e-14,7.16399548 7.16300688,-3.55271368e-15 15.9999451,-3.55271368e-15 C24.8369931,-3.55271368e-15 32,7.16399548 32,16.0000549 Z"
              id="Shape-Copy"
              fill="#FFFFFF"
            />
            <g id="Group" transform="translate(1.000000, 1.000000)">
              <circle id="Oval" fill="#1DA1F2" cx="15" cy="15" r="15" />
              <path
                d="M23.1039552,11.2834597 C22.9872645,11.4318063 22.8655658,11.5696283 22.738358,11.6969258 C22.6111502,11.8237221 22.4734253,11.9510196 22.3251832,12.078317 C22.1769411,12.2056145 22.0286989,12.3223873 21.8804568,12.4281345 L21.8804568,12.5238582 C21.8804568,12.5449074 21.885465,12.5764812 21.8959821,12.6190807 C21.9070002,12.6616803 21.9120084,12.693254 21.9120084,12.7143032 L21.9120084,12.8416007 C21.9120084,13.8379289 21.7211967,14.8613203 21.3400742,15.9107727 C20.9584509,16.960225 20.3970339,17.8984173 19.6558233,18.7248485 C18.9141118,19.5517809 17.9981157,20.2358794 16.9068332,20.7761419 C15.8155508,21.3169055 14.571018,21.5765122 13.1727342,21.5554629 C12.727507,21.5765122 12.2988067,21.5504513 11.8856319,21.4757767 C11.4724571,21.4016035 11.0642904,21.3118938 10.6621335,21.2056456 C10.2594759,21.0998984 9.87785257,20.9565635 9.51776443,20.7761419 C9.15767629,20.5962215 8.79758814,20.4107881 8.4375,20.2198419 C8.50110389,20.1987927 8.56470778,20.1932798 8.62831166,20.2038045 C8.69141472,20.214329 8.75501861,20.2198419 8.8186225,20.2198419 C8.88222639,20.2198419 8.94583027,20.2248537 9.00943416,20.2358794 C9.07303804,20.246404 9.13664193,20.2408912 9.20024581,20.2198419 C9.56033396,20.2408912 9.90990492,20.214329 10.2489587,20.1401558 C10.5880125,20.0659824 10.9160483,19.9812844 11.2340677,19.8860619 C11.5515863,19.7903383 11.8590885,19.6525162 12.1555728,19.4725958 C12.4520571,19.2921741 12.7380242,19.1172655 13.0134741,18.9478696 C12.6749212,18.9052701 12.3513927,18.8366096 12.0443913,18.7408859 C11.7373898,18.6456635 11.4564309,18.4973168 11.2020154,18.295846 C10.9481007,18.0943752 10.7307456,17.8718552 10.550952,17.6277849 C10.3706575,17.3842157 10.2274235,17.0925341 10.1217509,16.7532413 C10.1643205,16.7958409 10.2118982,16.81689 10.2644841,16.81689 C10.3175708,16.81689 10.3706575,16.8224029 10.4237442,16.8329275 C10.4763301,16.8434521 10.5244086,16.8434521 10.5664773,16.8329275 C10.6090469,16.8224029 10.6516164,16.8274146 10.6936851,16.8489649 C10.7783234,16.8274146 10.8524444,16.8224029 10.9160483,16.8329275 C10.9796522,16.8434521 11.0487651,16.8379392 11.1228861,16.81689 C11.1970072,16.7958409 11.2656193,16.7853162 11.3292232,16.7853162 C11.3928271,16.7853162 11.4564309,16.7637659 11.5200348,16.7216675 C11.1599467,16.6580188 10.83141,16.5307213 10.5349258,16.3397751 C10.2384415,16.1488289 9.97851699,15.926309 9.7561538,15.6722152 C9.53379061,15.4176203 9.35900512,15.120927 9.23179735,14.781634 C9.10458958,14.4423412 9.04098569,14.0925237 9.04098569,13.7321817 L9.04098569,13.6845705 C9.14715911,13.7532309 9.25834071,13.8118679 9.37503129,13.8434418 C9.49122107,13.8750155 9.60791167,13.9121021 9.72460226,13.9547017 C9.84079204,13.9973013 9.95748264,14.0238634 10.0741732,14.0343879 C10.190363,14.0449125 10.3125626,14.06095 10.4392696,14.0819992 C10.2274235,13.9121021 10.0421209,13.7427064 9.88336157,13.5733105 C9.72460226,13.4034135 9.58136831,13.2019427 9.45416055,12.9688981 C9.32745359,12.7358535 9.23179735,12.5023078 9.16819347,12.2692633 C9.10458958,12.0362187 9.07303804,11.7710991 9.07303804,11.4744058 C9.07303804,11.3681575 9.08355522,11.2408601 9.10458958,11.0925134 C9.12612476,10.9441668 9.15216728,10.8118576 9.18421964,10.6950848 C9.21627199,10.5783119 9.25834071,10.4510144 9.31142742,10.3131924 C9.36451412,10.1753703 9.42260901,10.0641103 9.4862129,9.97941236 C9.86733539,10.4249535 10.2910274,10.8434313 10.757289,11.2358484 C11.2235506,11.6277642 11.7268727,11.9565325 12.2667544,12.2216519 C12.807137,12.4867715 13.374063,12.7037786 13.9670315,12.8736756 C14.5605009,13.0430714 15.1750046,13.138294 15.8105427,13.1598443 C15.8105427,13.1172448 15.8050336,13.0641206 15.7945164,13.0004719 C15.7839993,12.9373244 15.7729812,12.8786873 15.7624641,12.8255632 C15.7519469,12.7729402 15.7469388,12.7143032 15.7469388,12.6506544 L15.7469388,12.4917832 C15.7469388,12.0467432 15.826068,11.6438017 15.9853281,11.2834597 C16.1440874,10.9231176 16.3614424,10.5943494 16.6363915,10.2976561 C16.9118414,10.0004616 17.2403781,9.77794154 17.6220013,9.62959489 C18.0031238,9.48124832 18.4057815,9.39655039 18.8294735,9.375 C19.0413195,9.39655039 19.2531656,9.42311242 19.4650116,9.4546862 C19.6768576,9.48625997 19.8781864,9.54990869 20.0689981,9.64563245 C20.2593089,9.74085495 20.4396034,9.84710318 20.6088799,9.96337489 C20.7786572,10.0801478 20.9268993,10.2234827 21.0541071,10.3928786 C21.2233835,10.3292298 21.3931609,10.2761057 21.5624373,10.2340073 C21.7322147,10.1914077 21.9014911,10.1382836 22.0707676,10.0746349 C22.2405449,10.0114873 22.3993042,9.94232567 22.5475463,9.86815239 C22.6957885,9.79397902 22.8440306,9.70376826 22.9927736,9.59802111 C22.950204,9.81001649 22.8810911,9.98993701 22.7859357,10.1382836 C22.6907803,10.2866302 22.5901159,10.4404898 22.4839425,10.5998622 C22.3782699,10.7587335 22.2510621,10.8910427 22.1028199,10.9972909 C21.9545779,11.1030381 21.8063358,11.2198109 21.6575928,11.3471084 C21.8063358,11.3045088 21.959586,11.272935 22.1188462,11.2513847 C22.2776055,11.2303355 22.4313566,11.1932488 22.5795987,11.1401247 C22.7278409,11.0870006 22.870574,11.0393893 23.0082989,10.9972909 C23.1460239,10.9546914 23.2892578,10.9015672 23.4375,10.8379185 C23.3318274,10.9972909 23.2201449,11.135113 23.1039552,11.2834597 L23.1039552,11.2834597 Z"
                id="tw-copy-3"
                fill="#FFFFFF"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const LinkedInIcon = () => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
    >
      <title>Artboard 2 Copy 9</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Artboard-2-Copy-9">
          <g id="Group-2">
            <path
              d="M32,16.0000549 C32,24.837103 24.8369931,32 15.9999451,32 C7.16289703,32 4.37128358e-14,24.8369931 4.37128358e-14,16.0000549 C4.37128358e-14,7.16399548 7.16300688,-3.55271368e-15 15.9999451,-3.55271368e-15 C24.8369931,-3.55271368e-15 32,7.16399548 32,16.0000549 Z"
              id="Shape-Copy"
              fill="#FFFFFF"
            />
            <g id="Group" transform="translate(1.000000, 1.000000)">
              <path
                d="M14.9999485,0 C23.2846811,0 30,6.71624576 30,15.0000515 C30,23.2838572 23.2846811,30 14.9999485,30 C6.71521597,30 0,23.2837542 0,15.0000515 C0,6.71634874 6.71531895,0 14.9999485,0 L14.9999485,0 Z"
                id="Shape"
                fill="#0E76A8"
              />
              <path
                d="M8.0149611,20.9998979 L10.8099194,20.9998979 L10.8099194,11.7165906 L8.0149611,11.7165906 L8.0149611,20.9998979 L8.0149611,20.9998979 Z M18.9036678,11.3950293 C17.5472292,11.3950293 16.3335358,11.888655 15.4725555,12.9782259 L15.4725555,11.6860581 L12.6673498,11.6860581 L12.6673498,21 L15.4725555,21 L15.4725555,15.963262 C15.4725555,14.8988115 16.4511751,13.8604004 17.6769604,13.8604004 C18.9027456,13.8604004 19.2050417,14.8988115 19.2050417,15.9372226 L19.2050417,20.999081 L22,20.999081 L22,15.7299284 C21.9998975,12.0699097 20.2610287,11.3950293 18.9036678,11.3950293 L18.9036678,11.3950293 Z M9.39937491,10.7888726 C10.1718184,10.7888726 10.7987498,10.1641308 10.7987498,9.39438523 C10.7987498,8.62463965 10.1718184,8 9.39937491,8 C8.62693144,8 8,8.62474177 8,9.39448734 C8,10.1642329 8.62693144,10.7888726 9.39937491,10.7888726 L9.39937491,10.7888726 Z"
                id="Shape"
                fill="#FFFFFF"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="h-6 w-6"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
};

const LoadMoreIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.2}
      stroke="currentColor"
      className="h-5 w-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
      />
    </svg>
  );
};

const ArrowDownIcon = () => {
  return (
    <svg
      className="-mr-1 ml-2 h-5 w-5"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
};

const FacebookIconStroy = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 512 512" fill="currentColor">
      <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
    </svg>
  );
};

const TwitterIconStroy = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 512 512" fill="currentColor">
      <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
    </svg>
  );
};
const WhatsAppIconStroy = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 512 512"
      className=" "
      // fill="currentColor"
    >
      <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
    </svg>
  );
};

const GoogleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="1.5rem" height="1.5rem">
    <path
      fill="#fbc02d"
      d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12	s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20	s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
    />
    <path
      fill="#e53935"
      d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039	l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
    />
    <path
      fill="#4caf50"
      d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36	c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
    />
    <path
      fill="#1565c0"
      d="M43.611,20.083L43.595,20L42,20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571	c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
    />
  </svg>
);
const AppleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="20px" height="20px">
    <path d="M 44.527344 34.75 C 43.449219 37.144531 42.929688 38.214844 41.542969 40.328125 C 39.601563 43.28125 36.863281 46.96875 33.480469 46.992188 C 30.46875 47.019531 29.691406 45.027344 25.601563 45.0625 C 21.515625 45.082031 20.664063 47.03125 17.648438 47 C 14.261719 46.96875 11.671875 43.648438 9.730469 40.699219 C 4.300781 32.429688 3.726563 22.734375 7.082031 17.578125 C 9.457031 13.921875 13.210938 11.773438 16.738281 11.773438 C 20.332031 11.773438 22.589844 13.746094 25.558594 13.746094 C 28.441406 13.746094 30.195313 11.769531 34.351563 11.769531 C 37.492188 11.769531 40.8125 13.480469 43.1875 16.433594 C 35.421875 20.691406 36.683594 31.78125 44.527344 34.75 Z M 31.195313 8.46875 C 32.707031 6.527344 33.855469 3.789063 33.4375 1 C 30.972656 1.167969 28.089844 2.742188 26.40625 4.78125 C 24.878906 6.640625 23.613281 9.398438 24.105469 12.066406 C 26.796875 12.152344 29.582031 10.546875 31.195313 8.46875 Z" />
  </svg>
);
const RedirectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="h-5 w-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
      />
    </svg>
  );
};

const UpArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="h-6 w-6"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
    </svg>
  );
};

const DownArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="h-6 w-6"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  );
};

const BookMark = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill ? "#ca4242" : "none"}
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#ca4242"
      className="h-6 w-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"
      />
    </svg>
  );
};

export {
  Bar3,
  LeftArrow,
  GotoArrow,
  DownArrow,
  UpArrow,
  MoonIcon,
  SunIcon,
  PorfileAvatar,
  SearchIcon,
  FacebookIcon,
  TwitterIcon,
  LinkedInIcon,
  InstaIcon,
  CloseIcon,
  LoadMoreIcon,
  AmpBar3,
  ProfileAvatarWhite,
  ArrowDownIcon,
  GoogleIcon,
  FacebookIconStroy,
  TwitterIconStroy,
  WhatsAppIconStroy,
  RedirectIcon,
  AppleIcon,
  BookMark,
};
